module.exports = __webpack_public_path__ + "img/account-parent.bcdda9ee.svg";